import * as XLSX from 'xlsx';

export default function exportarXlsx<T>(data: Array<T>, nomeArquivo: string) {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

  return XLSX.writeFile(wb, `${nomeArquivo}.xlsx`);
}
